import React, { useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { Glyph } from './Glyph';
import { theme } from '../theme';
import { usePhoneOrientation } from '../utils/useIsNarrowWindow';
/** localStorage key; once dismissed, the hint stays hidden in this browser. */
export const ROTATE_HINT_DISMISSED_KEY = 'rotatePhoneHintDismissed';
export const ROTATE_HINT_TEXT = 'Turn your phone sideways for a wider view';
export const isRotateHintDismissed = () => {
    try {
        return (typeof window !== 'undefined' &&
            !!window.localStorage &&
            window.localStorage.getItem(ROTATE_HINT_DISMISSED_KEY) === '1');
    }
    catch {
        return false;
    }
};
export const dismissRotateHint = () => {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem(ROTATE_HINT_DISMISSED_KEY, '1');
        }
    }
    catch {
        // Private browsing etc.: hide for this session only.
    }
};
/**
 * Small, dismissible note on wide tabs (Meal Map, Summary, Trends) when a
 * phone is held upright on the web. Browsers can't rotate the page for us,
 * so we suggest it. Hidden on desktops, tablets, landscape and native apps.
 */
export const RotatePhoneHint = ({ isPortraitPhone }) => {
    const live = usePhoneOrientation().isPortraitPhone;
    const show = isPortraitPhone ?? live;
    const [dismissed, setDismissed] = useState(isRotateHintDismissed);
    if (!show || dismissed) {
        return null;
    }
    return (<View style={styles.hint} testID="rotate-phone-hint">
      <Text style={styles.text}>{ROTATE_HINT_TEXT}</Text>
      <Pressable onPress={() => {
            dismissRotateHint();
            setDismissed(true);
        }} style={styles.closeHit} accessibilityRole="button" accessibilityLabel="Dismiss tip">
        <Glyph name="close" size={18} color={theme.colors.textCaption}/>
      </Pressable>
    </View>);
};
const styles = StyleSheet.create({
    hint: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        paddingLeft: 12,
        paddingVertical: 4,
        backgroundColor: theme.colors.surfaceElevated,
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: theme.colors.hairline,
    },
    text: {
        flex: 1,
        fontSize: 13,
        color: theme.colors.textCaption,
    },
    closeHit: {
        padding: 8,
    },
});
